
import React from 'react'
//import makeStyles from '@material-ui/core/styles/makeStyles'

export default function GridIcon(props) {
    const {  color } = props;
    //const classes = useStyles(props)()

    return(
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={color} d="M5.03207 9.74939C6.23059 9.74939 7.19111 10.7193 7.19111 11.9263V14.824C7.19111 16.0225 6.23059 17 5.03207 17H2.15903C0.969014 17 0 16.0225 0 14.824V11.9263C0 10.7193 0.969014 9.74939 2.15903 9.74939H5.03207ZM14.8413 9.74939C16.0313 9.74939 17.0003 10.7193 17.0003 11.9263V14.824C17.0003 16.0225 16.0313 17 14.8413 17H11.9683C10.7697 17 9.80923 16.0225 9.80923 14.824V11.9263C9.80923 10.7193 10.7697 9.74939 11.9683 9.74939H14.8413ZM5.03207 0C6.23059 0 7.19111 0.977515 7.19111 2.17688V5.07458C7.19111 6.28159 6.23059 7.25061 5.03207 7.25061H2.15903C0.969014 7.25061 0 6.28159 0 5.07458V2.17688C0 0.977515 0.969014 0 2.15903 0H5.03207ZM14.8413 0C16.0313 0 17.0003 0.977515 17.0003 2.17688V5.07458C17.0003 6.28159 16.0313 7.25061 14.8413 7.25061H11.9683C10.7697 7.25061 9.80923 6.28159 9.80923 5.07458V2.17688C9.80923 0.977515 10.7697 0 11.9683 0H14.8413Z" />
        </svg>
    )
}
